import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { observable } from 'mobx';

class OfficialMediaModalStore extends BaseModalStore {
  @observable communityType;
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  use() {}
}

export default OfficialMediaModalStore;
